<template>
  <nav style="z-index: 100">
    <v-toolbar :flat="currentUser === null" elevation="0">
      <v-app-bar-nav-icon
        @click="drawer = !drawer"
        class="text-grey"
        v-if="currentUser"
      ></v-app-bar-nav-icon>
      <v-toolbar-title class="text-uppercase color-text-second d-flex justify-end mr-6">
        <div class="d-flex align-center">
          <v-img width="40" :src="require('@/assets/logo.png')"></v-img>
          <div class="ml-2 font-weight-bold">DPMD<span class="font-weight-thin">BEKASI</span></div>
        </div>
      </v-toolbar-title>
    </v-toolbar>

    <v-navigation-drawer
      app
      class="nav-color-second"
      v-model="drawer"
      v-if="showNavbar"
    >
      <v-list nav>
        <v-list-item v-if="currentUser" class="mt-4" value="admin-profile">
          <div class="d-flex flex-row">
            <v-avatar>
              <v-img
                  :lazy-src="lookupImageUrlLazy(currentUser)"
                  :src="lookupImageUrl(currentUser)"
              ></v-img>
            </v-avatar>
            <div class="ml-2 d-flex flex-column">
              <div class="text-subtitle-2 text-white font-weight-bold">{{ currentUser.username }} </div>
              <div class="text-caption text-white font-weight-light">{{ currentUser.email }} </div>
            </div>
          </div>
        </v-list-item>
        <v-divider class="mt-4 text-white"></v-divider>
        <v-list-item class="text-white font-weight-medium" to="/dashboard-utama" link prepend-icon="mdi-rocket" value="dashboard">Dashboard</v-list-item>

        <v-list-group
            :value="nav_drawer.title"
            v-for="nav_drawer in nav_drawers.filter((x) => x.visible)"
            :key="nav_drawer.title">
              <template v-slot:activator="{ props }">
                <v-list-item
                    class="text-body-2 text-white font-weight-medium"
                    :prepend-icon="nav_drawer.icon"
                    v-bind="props"
                >{{nav_drawer.title}}</v-list-item>
              </template>
              <v-list-item
                v-for="submenu in nav_drawer.items.filter((x) => x.visible)"
                :key="submenu.title"
                link
                :to="submenu.route"
                class="text-white text-caption"
              >{{submenu.title}}</v-list-item>
        </v-list-group>

        <v-divider class="text-white"></v-divider>
        <v-list-group
            :value="nav_drawer.title"
            v-for="nav_drawer in nav_drawers_setup.filter((x) => x.visible)"
            :key="nav_drawer.title">
          <template v-slot:activator="{ props }">
            <v-list-item
                :prepend-icon="nav_drawer.icon"
                v-bind="props"
                class="text-body-2 text-white font-weight-medium"
            >{{nav_drawer.title}}</v-list-item>
          </template>
          <v-list-item
              v-for="submenu in nav_drawer.items.filter((x) => x.visible)"
              :key="submenu.title"
              link
              :to="submenu.route"
              class="text-white text-caption"
          >{{submenu.title}}</v-list-item>
        </v-list-group>

        <v-divider class="text-white"></v-divider>
        <v-list-item class="text-white font-weight-medium" prepend-icon="mdi-power" title="Keluar" value="keluar" @click="logOut"></v-list-item>
      </v-list>

      <div class="my-16">
      </div>

    </v-navigation-drawer>
  </nav>
</template>

<script>
import ERole from "../models/e-role";
import FileService from "../services/apiservices/file-service";
import TestService from "../services/test-service";
import EOrganizationLevel from "@/models/e-organization-level";

export default {
  components: {},
  data() {
    return {
      top_menus: [
        {
          icon: "mdi-pencil",
          title: "Ubah Profile",
          route: "/change-profile",
          action: "",
          visible: true,
          iconColor: "orange",
        },
        {
          icon: "mdi-power",
          title: "Keluar",
          route: "#",
          action: "logOut",
          visible: true,
          iconColor: "red",
        },
      ],
      drawer: true,
    };
  },
  watch: {},
  computed: {
    currentUser() {
      // console.log( `Isinya ${this.$store.state.auth.user}` )
      return this.$store.state.auth.user;
    },
    showNavbar() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles;
      }
      return false;
    },

    nav_drawers() {
      return [
        {
          title: "Profil",
          icon: "mdi-bank",
          active: false,
          visible: [ERole.ROLE_ADMIN].some((x) => this.currentUser.roles.includes(x)),
          items: [
            {
              title: "Profil Dinas",
              route: "/admin-profil-dinas",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
            {
              title: "Visi-Misi",
              route: "/admin-visi-misi",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
            {
              title: "Tugas & Fungsi",
              route: "/admin-tugas-fungsi",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
            {
              title: "Struktur Organisasi",
              route: "/admin-struktur-organisasi",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
            // {
            //   title: "Peraturan & Regulasi",
            //   route: "/admin-peraturan-regulasi",
            //   icon: "",
            //   visible: [ERole.ROLE_ADMIN].some((x) =>
            //       this.currentUser.roles.includes(x)
            //   ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            // },
            {
              title: "Manajemen Talenta",
              route: "/admin-manajemen-talenta",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
            {
              title: "Galeri Penghargaan",
              route: "/admin-galeri",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
          ],
        },
        {
          title: "Pegawai",
          icon: "mdi-account-tie",
          active: false,
          visible: [
            ERole.ROLE_ADMIN
          ].some((x) => this.currentUser.roles.includes(x)) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
          items: [
            {
              title: "Data Pegawai",
              route: "/admin-profil-pegawai",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
            {
              title: "DPMD Masa ke Masa",
              route: "/admin-dpmd-masa",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
            {
              title: "Golongan",
              route: "/admin-golongan",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
          ],
        },
        {
          title: "Berita",
          icon: "mdi-newspaper-variant",
          active: false,
          visible: [
            ERole.ROLE_ADMIN
          ].some((x) => this.currentUser.roles.includes(x)) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
          items: [
            {
              title: "Berita",
              route: "/admin-berita-agenda",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
          ],
        },
        {
          title: "Informasi PPID",
          icon: "mdi-cogs",
          active: false,
          visible: [
            ERole.ROLE_ADMIN
          ].some((x) => this.currentUser.roles.includes(x)) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
          items: [
            {
              title: "PPID",
              route: "/admin-ppid",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
            {
              title: "Kumpulan Informasi",
              route: "/admin-kumpulan-informasi",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
          ],
        },
        {
          title: "Layanan",
          icon: "mdi-account-cog",
          active: false,
          visible: [
            ERole.ROLE_ADMIN
          ].some((x) => this.currentUser.roles.includes(x)) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
          items: [
            {
              title: "Permohonan Informasi",
              route: "/admin-permohonan-informasi",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
            {
              title: "Pengajuan Keberatan",
              route: "/admin-pengajuan-keberatan",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
            {
              title: "Penyelesaian Sengketa",
              route: "/admin-penyelesaian-sengketa",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
          ],
        },
        {
          title: "Saran & Konsultasi",
          icon: "mdi-newspaper",
          active: false,
          visible: [
            ERole.ROLE_ADMIN
          ].some((x) => this.currentUser.roles.includes(x)) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
          items: [
            {
              title: "Saran Pengaduan",
              route: "/admin-saran",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
            {
              title: "Konsultasi",
              route: "/admin-konsultasi",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
          ],
        },
        {
          title: "Survei",
          icon: "mdi-newspaper",
          active: false,
          visible: [
            ERole.ROLE_ADMIN
          ].some((x) => this.currentUser.roles.includes(x)) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
          items: [
            {
              title: "Daftar Pertanyaan",
              route: "/admin-soal",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
            {
              title: "Setting Survei",
              route: "/admin-template-survei",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
            {
              title: "Hasil Survei",
              route: "/admin-survei",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
          ],
        },
        {
          title: "Indeks Desa",
          icon: "mdi-chart-bar",
          active: false,
          visible: [
            ERole.ROLE_ADMIN
          ].some((x) => this.currentUser.roles.includes(x)) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
          items: [
            {
              title: "Judul Index/Statistik",
              route: "/admin-dashboard-f-header-item",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
            {
              title: "Jenis Data",
              route: "/admin-dashboard-f-data-item",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
            {
              title: "Group Rekap Laporan",
              route: "/admin-dashboard-f-report-group",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
            {
              title: "Data per Desa",
              route: "/admin-dashboard-header-detil",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
          ],
        },
        {
          title: "Skor & Indikator",
          icon: "mdi-clipboard-list",
          active: false,
          visible: [
            ERole.ROLE_ADMIN
          ].some((x) => this.currentUser.roles.includes(x)) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
          items: [
            {
              title: "Dimensi",
              route: "/admin-dashboard-f-dimensi",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
            {
              title: "Sub Dimensi",
              route: "/admin-dashboard-f-sub-dimensi",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
            {
              title: "Perangkat Indikator",
              route: "/admin-dashboard-f-perangkat-indikator",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
            {
              title: "Indikator",
              route: "/admin-dashboard-f-indikator",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
            {
              title: "Klassifikasi",
              route: "/admin-dashboard-f-klassifikasi",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
            {
              title: "Skor Desa",
              route: "/admin-dashboard-ft-skor",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
          ],
        },
        {
          title: "Data Peta",
          icon: "mdi-map",
          active: false,
          visible: [
            ERole.ROLE_ADMIN
          ].some((x) => this.currentUser.roles.includes(x)) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
          items: [
            {
              title: "Data Peta",
              route: "/admin-data-peta-dataset",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
            {
              title: "Kabupaten",
              route: "/admin-data-peta-region",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
            {
              title: "Kecamatan",
              route: "/admin-data-peta-area",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
            {
              title: "Desa-Kelurahan",
              route: "/admin-data-peta-sub-area",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
          ],
        },
        {
          title: "Arsip (Dokumen)",
          icon: "mdi-archive",
          active: false,
          visible: [ERole.ROLE_ADMIN].some((x) =>this.currentUser.roles.includes(x)) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
          items: [
            {
              title: "Dokumen SOP",
              route: "/admin-sop",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) => this.currentUser.roles.includes(x)),
            },
            {
              title: "Arsip Internal",
              route: "/admin-arsip",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
            {
              title: "Kategori Arsip",
              route: "/admin-arsip-categ",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },

          ],
        },
      ];
    },

    nav_drawers_setup() {
      return [

        {
          title: "Setup",
          icon: "mdi-cog",
          active: false,
          visible: [ERole.ROLE_ADMIN].some((x) =>
              this.currentUser.roles.includes(x)
          ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
          items: [
            {
              title: "Gambar Slide",
              route: "/admin-din-carousel",
              icon: "mdi-image",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
            {
              title: "Seed Indikator",
              route: "/admin-seed-indikator",
              icon: "mdi-database-cog",
              visible: [ERole.ROLE_ADMIN, ERole.ROLE_ACC, ERole.ROLE_MANAGER, ERole.ROLE_SALES_ADM].some((x) =>
                  this.currentUser.roles.includes(x)
              ),
            },
            // {
            //   title: "Link Aplikasi",
            //   route: "/admin-app-link",
            //   icon: "",
            //   visible: [ERole.ROLE_ADMIN].some((x) =>
            //       this.currentUser.roles.includes(x)
            //   ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            // },
          ],
        },
        {
          title: "Admin",
          icon: "mdi-cog-outline",
          active: false,
          visible: [ERole.ROLE_ADMIN].some((x) =>
              this.currentUser.roles.includes(x)
          ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
          items: [
            {
              title: "Pengguna",
              route: "/admin-sistem",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
            {
              title: "Struktur Organisasi Sistem",
              route: "/admin-struktur-organisasi-sistem",
              icon: "",
              visible: [ERole.ROLE_ADMIN].some((x) =>
                  this.currentUser.roles.includes(x)
              ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            },
            // {
            //   title: "Setting Aplikasi",
            //   route: "/admin-setting-one",
            //   icon: "",
            //   visible: [ERole.ROLE_ADMIN].some((x) =>
            //       this.currentUser.roles.includes(x)
            //   ) && this.currentUser.organizationLevel !== EOrganizationLevel.DIV,
            // },
          ],
        },
      ];
    },
  },

  methods: {
    handleClick(action) {
      if (action !== "") {
        this[action]();
      }
    },
    logOut() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/login");
    },


    lookupImageUrl(item) {
      // console.log(JSON.stringify(item))
      if (item.avatarImage === undefined || item.avatarImage === "") {
        return require("@/assets/images/account_icon.png");
      } else {
        return FileService.image_url_verylow(item.avatarImage);
      }
    },
    lookupImageUrlLazy() {
      return require("@/assets/images/account_icon.png");
    },
  },
  mounted() {
    TestService.getAdminBoard().then(
      () => {},
      (error) => {
        if (error?.response?.status === 401 && this.currentUser) {
          this.$store.dispatch("auth/logout");
          this.$router.push("/login");
        }
      }
    );
  },
};
</script>

<style scoped>
.nav-color{
  background-image: linear-gradient(to top left, #00386c 10%, transparent 90%);
}
.nav-color-second{
  background-color: #002647;
}
</style>
